import {AES, enc} from "crypto-js";
import {Constants} from "./Constants";

// Função para criptografar uma string usando AES
export const encryptAES = (plainText: any) => {
    return AES.encrypt(plainText, Constants.SECRET_KEY).toString();
}

// Função para descriptografar uma string usando AES
export const decryptAES = (encryptedText: any) => {
    const bytes = AES.decrypt(encryptedText, Constants.SECRET_KEY);
    return bytes.toString(enc.Utf8);
}

// Função para codificar uma string em Base64 com substituição do caractere "+"
export const encodeBase64Safe = (input: any) => {
    const base64 = btoa(input);
    return base64.replace(/\+/g, "-").replace(/\//g, "_");
}

// Função para decodificar uma string em Base64 com substituição do caractere "+"
export const decodeBase64Safe = (input: any) => {
    const base64 = input.replace(/-/g, "+").replace(/_/g, "/");
    return atob(base64);
}

// Função para criptografar uma string usando AES e codificar em Base64 com substituição do caractere "+"
// Maneira segura de enviar via url
export const encryptBase64Safe = (plainText: any) => {
    const encrypted = encryptAES(plainText);
    return encodeBase64Safe(encrypted);
}

// Função para decodificar uma string em Base64 com substituição do caractere "+" e descriptografar usando AES
export const decryptBase64Safe = (encryptedText: any) => {
    const decoded = decodeBase64Safe(encryptedText);
    return decryptAES(decoded);
}
